import React, {useEffect, useReducer, useState} from 'react';
import HundContainer from './containers/HundContainer';
import Forside from "./components/Forside";
//import FAQContainer from './containers/FAQContainer';
import {BrowserRouter, Route, Switch, useLocation} from "react-router-dom"
import Header from './containers/Header';
import LoggetUt from "./components/LoggetUt";
import Error from "./components/Error";
//import {FaqContextProvider} from "./context";
import 'babel-polyfill';
import {
    dummyRestKall,
    getFavorittHunder,
    getSisteHunder,
    getMineHunder,
    getPersonIdGyldigBruker,
    isUserAuthenticated
} from './api';
import ErrorTekst from "./components/ErrorTekst";

import ScrollToTop from "./components/ScrollToTop";

const App = () => {
    return (
        <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
            <AppContent />
        </BrowserRouter>
    );
}


const AppContent = ( ) => {
    const location = useLocation();
    const pathname = location.pathname;

    const isLoggedOutPage = pathname.endsWith("/logout");
    const [notGyldigBruker, setNotGyldigBruker] = useState(false);
    const loggedOut = isLoggedOutPage || notGyldigBruker;

    const match = pathname.match(/\/hund\/id\/([^/]+)/);
    const id = match ? match[1] : null;

    const [hundId, setHundId] = useState(null);
    const {userAuthenticated} = useFetchUserAuthenticated();
    const {gyldigBruker, errorCode} = useFetchIsGyldigBruker(isLoggedOutPage, userAuthenticated, id);
    const {personIdGyldigBruker} = useFetchPersonIdGyldigBruker(userAuthenticated);

    const {sisteHunder} = useFetchSisteHunder(hundId, gyldigBruker);
    const [count, forceUpdate] = useReducer(x => x + 1, 0);
    const {favoritter} = useFetchFavoritter(gyldigBruker, count);
    const {mineHunder} = useFetchMineHunder(gyldigBruker);

    useEffect(() => {
        if (gyldigBruker === false && id == null) {
            setNotGyldigBruker(true);
        } else if (gyldigBruker === true) {
            setNotGyldigBruker(false);
        }
    }, [gyldigBruker]);

    useEffect(() => {
        if (id !== null) {
            setNotGyldigBruker(false);
        }
    }, [id]);


    const getLoadedHundId = (t) => {
        setHundId(t);
    };


    const reLoadFavoritter = () => {
        forceUpdate();
    };

    let showHeader = false;
    if(gyldigBruker != null || errorCode !== null || loggedOut) showHeader = true;

    return (
        <>
            {showHeader && <Header userAuthenticated={userAuthenticated} />}
            <div className="grid-container grey-bg">
                <div className="grid-x">
                    <div className="cell small-24 large-16 large-offset-4">

                        <ScrollToTop/>
                        <Switch>
                            {gyldigBruker &&
                                <>
                                    <Route path="/" exact={true} render={() =>
                                        <Forside sisteHunder={sisteHunder} favoritter={favoritter} mineHunder={mineHunder} />}
                                    />
                                    <Route path="/hund/id/:id" render={routeProps =>
                                        <HundContainer {...routeProps}
                                                       personIdGyldigBruker={personIdGyldigBruker}
                                                       hundIdGetter={getLoadedHundId}
                                                       sisteHunder={sisteHunder}
                                                       favoritter={favoritter}
                                                       reLoadFavoritter={reLoadFavoritter}
                                                       bevis={true} />}
                                    />

                                    <Route path="/hund" render={routeProps =>
                                        <HundContainer {...routeProps}
                                                       personIdGyldigBruker={personIdGyldigBruker}
                                                       hundIdGetter={getLoadedHundId}
                                                       sisteHunder={sisteHunder}
                                                       favoritter={favoritter}
                                                       reLoadFavoritter={reLoadFavoritter}
                                                       bevis={false} />}
                                    />

                                </>
                            }
                            <Route path="/hund/id/:id" render={routeProps =>
                                <HundContainer {...routeProps} hundIdGetter={getLoadedHundId} bevis={true} />}
                            />
                            <Route path="/logout" render={() => <LoggetUt/>}/>
                        </Switch>

                        {(!loggedOut || notGyldigBruker) && errorCode !== null && id === null &&
                            <Error>
                                <ErrorTekst errorCode={errorCode}/>
                            </Error>
                        }

                    </div>
                </div>
            </div>
        </>

    );
}



const useFetchIsGyldigBruker = (loggedOut, userAuthenticated, bevisId) => {
    const [gyldigBruker, setGyldigBruker] = useState(null);
    const [errorCode, setErrorCode] = useState(null);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setGyldigBruker(null);
                setErrorCode(null);
            }

            if (bevisId !== null && bevisId !== '') {
                if (isMounted) {
                    setGyldigBruker(userAuthenticated ? true : false);
                }
                return;
            }

            dummyRestKall(null)
                .then((data) => {
                    if (isMounted) {
                        if (data === 'OK') {
                            setGyldigBruker(true);
                        }
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        if (err.message === '403') {
                            setErrorCode(403);
                            setGyldigBruker(false);
                        } else {
                            setErrorCode(500);
                        }
                    }
                });
        };


        if (!loggedOut && userAuthenticated !== null) {  // ← vent til userAuthenticated er satt
            fetchData();
        }
        return () => {
            isMounted = false;
        };
    }, [loggedOut, userAuthenticated, bevisId]);

    return { gyldigBruker, errorCode };
};

const useFetchFavoritter = (gyldigBruker, count) => {
    const [favoritter, setFavoritter] = useState([]);
    //const [isUtstillingsresultaterLoading, setIsUtstillingsresultaterLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {

            }
            getFavorittHunder()
                .then((data) => {
                    if (isMounted) {
                        setFavoritter(data);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        //setIsUtstillingsresultaterLoading(false);
                        //setUtstillingsresultater(null);
                    }
                });
        };
        //console.log(hundId);

        if (gyldigBruker !== null && gyldigBruker) {
            fetchData();
        }
        return () => {
            isMounted = false;
        };
    }, [gyldigBruker, count]);
    return { favoritter };
};


const useFetchUserAuthenticated = () => {
    const [userAuthenticated, setUserAuthenticated] = useState(null);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setUserAuthenticated(null);
            }
            isUserAuthenticated()
                .then((data) => {
                    if (isMounted) {
                        setUserAuthenticated(data);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {

                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, []);
    return { userAuthenticated };
};

const useFetchPersonIdGyldigBruker = (userAuthenticated) => {
    const [personIdGyldigBruker, setPersonIdGyldigBruker] = useState(null);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setPersonIdGyldigBruker(null);
            }
            getPersonIdGyldigBruker()
                .then((data) => {
                    if (isMounted) {

                        setPersonIdGyldigBruker(data);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {

                    }
                });
        };
        //console.log(hundId);

        if (userAuthenticated !== null && userAuthenticated ) {
            fetchData();
        }
        return () => {
            isMounted = false;
        };
    }, [userAuthenticated]);
    return { personIdGyldigBruker };
};


const useFetchMineHunder = (gyldigBruker) => {
    const [mineHunder, setMineHunder] = useState([]);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {

            }
            getMineHunder()
                .then((data) => {
                    if (isMounted) {
                        setMineHunder(data);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {

                    }
                });
        };
        //console.log(hundId);

        if (gyldigBruker !== null && gyldigBruker) {
            fetchData();
        }
        return () => {
            isMounted = false;
        };
    }, [gyldigBruker]);
    return { mineHunder };
};



const useFetchSisteHunder = (hundId, gyldigBruker) => {
    const [sisteHunder, setSisteHunder] = useState([]);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {

            }
            getSisteHunder()
                .then((data) => {
                    if (isMounted) {
                        setSisteHunder(data);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        //setIsUtstillingsresultaterLoading(false);
                        //setUtstillingsresultater(null);
                    }
                });
        };
        //console.log(hundId);

        if (gyldigBruker !== null && gyldigBruker && hundId !== undefined) {

            fetchData();
        }
        return () => {
            isMounted = false;
        };
    }, [hundId, gyldigBruker]);
    return { sisteHunder };
};

export default App;
